module.exports = __webpack_public_path__ + "img/Icon-survey-un-locked.586ef336.svg";